export default {
  methods: {
    checkRequired(val, prop, name, errors) {
      if (!val) {
        errors[prop] = [`${name}は必須項目です`]
      }
    },
  }
}
